module.exports = __webpack_public_path__ + "img/rs.af6cd01b.svg";